module.exports = __webpack_public_path__ + "static/media/icon_channel_band.13540a71.svg";